import { getAllEventsAnalytics } from "./get-all-events-analytics";
import { getDeliveryAnalytics } from "./get-delivery-analytics";
import { getDeliveryAnalyticsAggregates } from "./get-delivery-analytics-aggregates";
import { getDeliveryAnalyticsV2Charts } from "./get-delivery-analytics-v2-charts";
import { getDeliveryAnalyticsV2FilterOptions } from "./get-delivery-analytics-v2-filter-options";
import { getDeliveryAnalyticsV2Tables } from "./get-delivery-analytics-v2-tables";
import { getOrderTrackingAnalytics } from "./get-order-tracking-analytics";
import { getOrderTrackingAnalyticsVisibility } from "./get-order-tracking-analytics-visibility";
import { getProblemOrdersAnalytics } from "./get-problem-orders-analytics";
import { getTrackingEmailsAndPageAnalyticsAggregates } from "./get-tracking-emails-and-page-analytics-aggregates";
import { getTrackingPagesMetrics } from "./get-tracking-pages-metrics";
import { getUpsellAnalytics } from "./get-upsell-analytics";

export const orderTrackingAnalyticsSchema = {
  getAllEventsAnalytics,
  getDeliveryAnalytics,
  getDeliveryAnalyticsAggregates,
  getDeliveryAnalyticsV2Charts,
  getDeliveryAnalyticsV2FilterOptions,
  getDeliveryAnalyticsV2Tables,
  getOrderTrackingAnalytics,
  getOrderTrackingAnalyticsVisibility,
  getProblemOrdersAnalytics,
  getTrackingEmailsAndPageAnalyticsAggregates,
  getTrackingPagesMetrics,
  getUpsellAnalytics,
};
